module.exports = "/images/video.svg?a094b723aa0a0a24975e6e3fbe6930c4";